export function formatList(content: string, language: 'nl' | 'en'): string {
  const lines = content.split('\n');
  const title = lines[0].includes('-') ? '' : lines[0];
  
  const items = lines
    .filter(line => line.includes('-'))
    .map(line => line.trim());
    
  return title 
    ? `${title}\n\n${items.join('\n')}`
    : items.join('\n');
}